{
	"priceForecast": {
		"title": "Прогноз цены",
		"description": "Прогноз цены {{symbol}} на год от {{count}} аналитиков: максимальная прогнозируемая цена составляет {{maxPrice}}, минимальная - {{minPrice}}.",
		"maxPrice": "Макс. цена",
		"avgPrice": "Сред. цена",
		"minPrice": "Мин. цена",
		"maxLine": "Макс.",
		"minLine": "Мин.",
		"avgLine": "Сред."
	}
}
